import React, {useState} from 'react';
import {Trans} from 'gatsby-plugin-react-i18next';
import {Resources} from '../links/Resources';
import {MenuItem, LinkWrapper, TriangleArrow, DropdownMenu} from '../utils/Styled';

export const ResourcesSelector: React.FC = () => {
  const [isOpen, setOpen] = useState(false);

  return (
    <MenuItem onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <LinkWrapper>
        <Trans>Resources</Trans>
      </LinkWrapper>
      <DropdownMenu visible={isOpen} minWidth="400px" left="-125px" leftMobile="-105px" column>
        <TriangleArrow visible={isOpen} left="calc(35% - 12px)" />
        <Resources itemClick={() => setOpen(false)} />
      </DropdownMenu>
    </MenuItem>
  );
};
